import React from 'react';
import Header from '../assets/fundo2_logo.png';

const header = () =>{
    return(
        <img src={Header} style={{ width: "100%"}} alt="footer" />
    )};
export default header;



// WEBPACK FOOTER //
// ./src/components/header.js